<template>
    <main class="page-main">
        <section class="section-content music-section">

            <!-- Section content -->
            <div class="content-wrapper-404">
                <h1>404</h1>
                <h2>URL Not Found</h2>
                <span><p class="not-exist">The page you’ve requested doesn’t exist.</p>
                    If you typed the address of the page in address bar, please check your type.  If you got here by clicking a link, then, the link might have became obsolete, cause the entertainment program was updated, and some movies are not listed in our catalog anymore.
                    <p>Please, try to refresh the page, or go to our <router-link to="/">catalog</router-link>. </p>
                </span>

            </div>
            <!-- /Section content -->
        </section>
    </main>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        props:['category'],
        name: "MusicPage",
        computed:{
            ...mapGetters({
                menu: 'getMenu',
                loading: 'getLoading',
            }),
            page () {
                if(this.menu.length > 0) {
                    return this.menu[3]
                } else {
                    return false;
                }
            },
        },
        created(){
            if(this.category === undefined){
                this.$router.replace({ name : this.page.route, params:{ category : this.page.categories[0].props}})
            }
        },
    }
</script>

<style scoped>
.content-wrapper-404{
    width: 703px;
    margin-left: 210px;
}
@media screen and (max-width: 968px) {
    .content-wrapper-404{
        width: 703px;
        margin-left: 10%;
    }
}
@media screen and (max-width: 768px) {
    .content-wrapper-404{
        width: auto;
    }
}
@media screen and (max-width: 580px) {
    .content-wrapper-404{

        width: auto;
        margin-left: 5%;
    }
}
@media screen and (max-width: 360px) {
    .content-wrapper-404{

        width: auto;
        margin-left: 2%;
        margin-right: 2%;
    }
}
    .not-exist{
        color: #FFFFFF;
        font-family: "PT Sans";
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
    }
</style>
